import { Controller } from "stimulus";
import notify from "../../packs/notify";
import i18next from "i18next";
import i18n from "../../packs/i18n";
import axios from "axios";
import utils from "../../packs/utils";

const contentSelector = "[data-portal--submission-target='content']";
const autoCompleteHiddenSelector = "[data-portal--submission-target='autoCompleteHidden']"
const portalExpressHiddenItem = createPortalExpressHidden()

export default class extends Controller {
  static targets = [
    "tabs",
    "form",
    "animalAmountType",
    "submissionOriginType",
    "setupSpecimenCount",
    "setupAnimalCount",
    "noPreviousSubmit",
    "noNextSubmit",
    "content",
    // these 3 targets coming from setup page
    "setupAnimalSexCodeId",
    "setupAnimalBreedId",
    "setupAnimalBreedLabel",
    "autoCompleteHidden",
    "setupIncrementalId",
    "setupIncrementalName",
    "item",
    "bulkUploadTab",
    "setupSpecimenTypeIds",
    "setupSpecimenTypeDescriptionIds",
    "setupTransportMediumIds",
    "setupCollectionDates"
  ];

  static values = {
    preSelectedCountry: { type: Number, default: 0 },
    targetLink: String,
    targetLinkType: { type: String, default: "" },
    accessionId: Number,
    autosaveDelay: Number,
    currentUserId: Number,
    checkMSInputs: { type: Boolean, default: false },
    currentUserLocale: String,
    isTabChange: { type: Boolean, default: false },
    isDebounce: { type: Boolean, default: false },
    setupTaxonId: { Number, default: 0 },
    setupTaxonLabel: String,
    submissionOriginType: String,
    submissionTypeMap: {
      type: Object,
      default: {
        product: i18next.t("Non-Animals"),
        animal: i18next.t("Animals"),
      },
    },
    setupAnimalSexCodeId: { type: Number, default: 0 },
    setupAnimalBreedId: { type: Number, default: 0 },
    isBulkUpload: { type: Boolean, default: false },
    tabName: { type: String, default: "accession" }
  };

  static DEFAULT_AUTOSAVE_DELAY = 500;

  initialize() {
    this.submitForm = this.submitForm.bind(this);
  }

  connect() {
    this.boundHandleFrame = this.handleFrame.bind(this);
    this.element.addEventListener("turbo:frame-render", this.boundHandleFrame);
    this.boundCheckAnimalsCount = this.checkAnimalsCount.bind(this);
    document.addEventListener(
      "portal--submission-animal:triggerAnimalCountProcess",
      this.boundCheckAnimalsCount
    );
    this.checkAndSetLanguage();
  }

  uploadedBulkUploadFile(e) {
    e.detail.fetchResponse.response.text().then(value => {
      if (value.indexOf('submission_form_tab_error') > -1) {
        this.manageTurboFrameError();
        return
      }
      const uploadReviewTab = this.getElement('bulk_upload_review_tab')
      uploadReviewTab.hidden = false
      if (value.indexOf('has_critical_error') > -1) this.hasUploadCriticalErrorValue = true
      //Need to be adjust our main tabs index and htmls 
      this.refreshTabs()
      this.tabNameValue = "bulk_upload_review"
      this.toggleTabs()
      this.setSpreadsheetsFiles()
    })
  }

  setSpreadsheetsFiles() {
    const spreadsheetItem = this.getElement('uploaded')
    const files = spreadsheetItem ? spreadsheetItem.files : ""
    if (!files) return

    let frame = this.getElement("submission_form_tab");
    frame.loaded.then( res => {
      setTimeout(function () {
        const bulkTemplate = document.getElementById('bulk_upload_template')
        if (bulkTemplate) bulkTemplate.files = files;
        }, 100);
    })
  }

  sentTurboStreamForm(e) {
    e.detail.fetchResponse.response.text().then(value => {
      if (value.indexOf('submission_form_tab_error') > -1) {
        this.manageTurboFrameError();
        return
      }
      this.setTabNameByResponse(value)
      this.refreshTabs()
      this.toggleTabs()
    })
  }

  setTabNameByResponse(value) {
    const tab_names = ['accession', 'veterinarian', 'setup', 'animal', 'specimen', 'test', 'predefined_test_results', 'review', 'print', 'additional_data', 'user_agreement']
    this.tabNameValue = tab_names.find(item => {
      return value.indexOf("data-tabName='" + item + "'") > -1
    })
  }

  manageTurboFrameError() {
    let frame = this.getElement("submission_form_tab_error");
    frame.loaded.then(res => {
      setTimeout(function () {
        document.getElementById('turbo_flash_message_container').hidden = true
      }, 10000);
    })
  }

  sentToReviewBulkUploadFile(e) {
    e.detail.fetchResponse.response.text().then(value => {
      if (value.indexOf('submission_form_tab_error') > -1) {
        this.manageTurboFrameError();
        return
      }
      this.getElement('bulk_upload_review_tab').hidden = true
      this.setupAnimalCountValue = utils("countTotalWord", value, "animal_details")
      this.toggleAmountOfAnimal(e, true)
      this.refreshTabs()
      this.toggleTabs()
      let url = e.target.dataset.visitUrl
      if (url) Turbo.visit(url, { frame: 'submission_form_tab' });
    })
  }

  refreshTabs() {
    const targets = this.tabsTargets.filter((elem) => !elem.parentNode.hidden)
    for (let i = 0; i < targets.length; i++) {
      const tab = targets[i];
      tab.innerHTML = "" + (i + 1)
    }
  }

  checkAndSetLanguage() {
    i18n.then(() => {
      i18next.changeLanguage(this.currentUserLocaleValue, (err, t) => {
        if (err)
          return console.error("something went wrong loading i18 locale", err);
      });
    });
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-render", this.boundHandleFrame);
    document.removeEventListener("autocomplete:triggerAutocompleteChangeEvent", this.boundSetTaxonValueAndId);
    this.setValuesForProgressiveButtons();
  }

  handlePrevious(event) {
    this.setPrevents(event);
    this.setValuesForProgressiveButtons();
    this.isTabChangeValue = true
    if (!this.hasNoPreviousSubmitTarget && this.hasFormTarget && this.validateForm(true)) {
      const prevOriginalFormUrl = this.getElement('prev_original_form_url')
      if (prevOriginalFormUrl) {
        this.formTarget.action = prevOriginalFormUrl.value
      }
      const partial = this.formTarget.prev_partial.value
      this.submitForm(event, this.formTarget, partial)
    } else {
      this.generateTargetUrl(event);
      this.visitUrl(this.targetLinkValue, "submission_form_tab");
    }
  }

  handleNext(event) {
    this.setPrevents(event);
    this.setValuesForProgressiveButtons()
    if ((!this.hasNoNextSubmitTarget || !this.hasNoPreviousSubmitTarget) && this.hasFormTarget) {
      this.setFormTargetAction()
      let partial = null
      if (this.formTarget.next_partial) {
        partial = this.formTarget.next_partial.value
      }
      this.submitForm(event, this.formTarget, partial)
    } else {
      this.generateTargetUrl(event);
      this.visitUrl(this.targetLinkValue, "submission_form_tab");
    }
  }

  setValuesForProgressiveButtons() {
    this.isTabChangeValue = false;
    this.isDebounceValue = false;
  }

  prepareVisitUrl(res) {
    if (!res) return

    if (res.status >= 200 && res.status <= 299) {
      this.visitUrl(this.targetLinkValue, "submission_form_tab");
    } else {
      notify({
        message: i18next.t('Something Went Wrong') + " : " + res,
        status: "error",
      });
    }
  }

  autosave(event) {
    const autoSaveUrl = this.getElement("auto_save_url");
    if (autoSaveUrl) {
      this.formTarget.action = autoSaveUrl.value;
    }
    if (!this.validateForm(true)) {
      event.preventDefault();
      return;
    } else {
      if (this.autoSaveTimeoutID) {
        clearTimeout(this.autoSaveTimeoutID);
      }
      this.autoSaveTimeoutID = setTimeout(() => {
        this.isDebounceValue = true;
        this.submitForm(event, this.formTarget);
      }, this.autosaveDelayValue || DEFAULT_AUTOSAVE_DELAY);
    }
  }

  tabChangeSetup(e) {
    this.setPrevents(e);
    if (!this.hasNoPreviousSubmitTarget && this.hasFormTarget && this.validateForm(true) && !this.isSendingSubmission()) {
      this.isDebounceValue = false;
      const partial = e.target.dataset.partial
      this.submitForm(e, this.formTarget, partial).then((res) => { });
    } else {
      this.goToTab(e);
    }
  }

  isSendingSubmission(){
    let formData = new FormData(this.formTarget);
    return formData.get('send_submission_form') == "true"
  }

  tabChange(e) {
    this.setPrevents(e);
    const partial = e.target.dataset.partial
    if ((!this.hasNoPreviousSubmitTarget && this.hasFormTarget && this.validateForm(true)) && partial !== "/portal/tabs/print_tab" && !this.isSendingSubmission()) {
      this.isDebounceValue = false;
      const partial = e.target.dataset.partial
      this.submitForm(e, this.formTarget, partial).then((res) => { });
    } else {
      this.goToTab(e)
    }
  }

  goToTab(e) {
    this.setPrevents(e);
    this.getElement('bulk_upload_review_tab').hidden = true
    const params = new URLSearchParams();
    let mainUrl = e.target.dataset.path
    let queryString = this.generateTargetUrl(e)
    queryString = queryString ? queryString.toString() : "";
    if (queryString) mainUrl = mainUrl + queryString
    const url = mainUrl + "&" + params.toString();
    Turbo.visit(url.toString(), { frame: 'submission_form_tab' });
  }

  generateTargetUrl(event) {
    const params = new URLSearchParams();
    params.append("id", parseInt(this.accessionIdValue));
    if (this.targetLinkTypeValue) {
      params.append("target_type", this.targetLinkTypeValue);
    }

    params.append("submission_origin_type", this.submissionOriginTypeValue);
    params.append('portal_express', true)

    if (this.hasSetupSpecimenCountTarget) {
      params.append("setup_specimen_count", parseInt(this.setupSpecimenCountTarget.value));
    }

    if (this.hasSetupAnimalCountTarget) {
      params.append("setup_animal_count", parseInt(this.setupAnimalCountTarget.value));
    }

    if (this.hasSetupAnimalSexCodeIdTarget) {
      this.setupAnimalSexCodeIdValue = this.setupAnimalSexCodeIdTarget.value
      if (this.setupAnimalSexCodeIdTarget.value) params.append("setup_animal_sex_code_id", this.setupAnimalSexCodeIdTarget.value);
    }

    const hiddenTarget = this.getAutoCompleteWithContentAndId('setup_animal_breed_id', autoCompleteHiddenSelector)
    if (hiddenTarget) {
      this.setupAnimalBreedIdValue = hiddenTarget.value
      if (hiddenTarget.value) params.append("setup_animal_breed_id", hiddenTarget.value);
    }

    if (this.hasSetupIncrementalIdTarget) {
      if (this.setupIncrementalIdTarget.value) params.append("setup_incremental_id", this.setupIncrementalIdTarget.value);
    }

    if (this.hasSetupIncrementalNameTarget) {
      if (this.setupIncrementalNameTarget.value) params.append("setup_incremental_name", this.setupIncrementalNameTarget.value);
    }

    if (this.hasSetupSpecimenTypeIdsTarget) {
      const itemsValues = this.getValuesByID("setup_specimen_type_ids_")
      if (itemsValues.length) params.append("setup_specimen_type_ids", itemsValues);
    }

    if (this.hasSetupSpecimenTypeDescriptionIdsTarget) {
      const itemsValues = this.getValuesByID("setup_specimen_type_description_ids_")
      if (itemsValues.length) params.append("setup_specimen_type_description_ids", itemsValues);
    }

    if (this.hasSetupTransportMediumIdsTarget) {
      const itemsValues = this.getValuesByID("setup_transport_medium_ids_")
      if (itemsValues.length) params.append("setup_transport_medium_ids", itemsValues);
    }

    if (this.hasSetupCollectionDatesTarget) {
      const itemsValues = this.getValuesByID("setup_collection_dates_")
      if (itemsValues.length) params.append("setup_collection_dates", itemsValues);
    }

    // if we have checkMSInputs mark in progress button page like handleNext or Previous buttons
    //  we will need to check extra input validation for Test page specimen records
    const checkMSInputs = event.currentTarget.getAttribute(
      "data-checkMSInputs"
    );

    this.checkMSInputsValue = checkMSInputs ? true : false;
    const url = event.currentTarget.getAttribute("data-target-link");
    this.targetLinkValue = url + "?" + params.toString();
    return params;
  }

  getValuesByID(id) {
    const items = document.querySelectorAll("[id=" + id + "]")
    if (items) return Array.from(items).map((element) => element.value)
    return []
  }

  getAutoCompleteWithContentAndId(id, selector) {
    return document.querySelector(`${selector}[id="${id}"]`)
  }

  findCheckedValue(targets) {
    return targets.find((elem) => elem.checked);
  }

  setPrevents(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  setFormTargetAction() {
    const formElem = this.formTarget;
    const originalFormUrl = this.getElement('original_form_url')
    if (originalFormUrl) {
      formElem.action = originalFormUrl.value
    }
  }

  // Should be button pointer event
  submitForm(event, formElem, partial = null) {
    if (!this.isTabChangeValue) {
      if (!this.validateForm()) {
        event.preventDefault();
        const msg = i18next.t("Please complete the required fields");
        notify({
          message: msg,
          status: "error",
        });
        return Promise.reject(new Error(msg));
      }
    }

    let formData = new FormData(formElem);
    let owner_id = document.querySelector("#owner_owner_id");
    if (owner_id) {
      formData.append("owner_id", owner_id.value);
      this.formTarget.owner_id.value = owner_id.value
    }
    formData.append("current_user_id", this.currentUserIdValue)
    if (this.formTarget.next_partial) {
      this.formTarget.partial.value = this.formTarget.next_partial.value
      if (partial) {
        formData.append('partial', partial)
        this.formTarget.partial.value = partial
      } else {
        try {
          formData.append('partial', this.formTarget.next_partial.value)
          this.formTarget.partial.value = this.formTarget.next_partial.value
        } catch (error) { }
      }
    }

    formData.append('portal_express', true)
    if (portalExpressHiddenItem) this.formTarget.appendChild(portalExpressHiddenItem)

    if (!this.isDebounceValue) {
      // Start bulk upload process if we have uploaded
      if (formData.has("uploaded") || formData.has("bulk_upload_template")) {
        this.bulkUploadActions()
        return Promise.resolve("")
      } else {
        Turbo.navigator.submitForm(this.formTarget)
        return Promise.resolve()
      }
    } else {
      this.isBulkUploadValue = false;
      if (this.isDebounceValue) {
        this.fetchForm(formElem.action, formData);
        return Function();
      } else {
        return this.fetchForm(formElem.action, formData);
      }
    }
  }

  async bulkUploadActions() {
    this.isBulkUploadValue = true;
    Turbo.navigator.submitForm(this.formTarget)
  }

  getFormSendMethod(type) {
    return type ? type : "PATCH";
  }

  async fetchForm(url, formData) {
    return fetch(url, {
      method: this.getFormSendMethod(formData.get("submit_method")),
      // TODO: (cjarvis) - Move fetch to use axios requests so we can use the same headers
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": axios.defaults.headers.common["X-CSRF-Token"],
      },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          return response.text();
        } else {
          return response;
        }
      })
      .then(function (resData) {
        return resData;
      })
      .catch(function (err) {
        notify({
          message: i18next.t('Something Went Wrong') + " : " + err,
          status: "error",
        });
      });
  }

  validateForm(isAutoSave = false) {
    let isValid = true;
    // Tell the browser to find any required fields
    let requiredFieldSelectors =
      "textarea:required, input:required, select:required, [data-valid='false']";
    let requiredFields = this.formTarget.querySelectorAll(
      requiredFieldSelectors
    );
    let firstfield = "";
    for (let index = 0; index < requiredFields.length; index++) {
      const field = requiredFields[index];
      const isChecked = field.type == "checkbox" ? field.checked : true;
      let dataValid = true;
      if (field.getAttribute("data-valid")) {
        dataValid = field.getAttribute("data-valid") === "true";
      }
      // For each required field, check to see if the value is empty
      // if so, we focus the only first field to attention the user start from first required field on the screen and set our value to false
      if (!field.disabled && !field.value.trim() || !isChecked || !dataValid) {
        // In case input is inside the expanded card, we want to open it up
        const cardContainer = field.closest('[data-controller="card"]')
        if (cardContainer) this.openCard(cardContainer)


        // if the current page in test page we need to check Specimen Multi Select container search value is valid.
        // if is not valid , we need to change classList
        if (this.checkMSInputsValue) {
          const msItem = document.querySelector("input:not([style])[data-multiselect-target='search']")
          msItem ? msItem.classList.add("required-field") : ""
        }

        isValid = false;
        if (isAutoSave) {
          return isValid
        }
        field.classList.add("required-field");
        if (!firstfield) firstfield = field;
      } else {
        field.classList.remove("required-field");
      }
    }
    firstfield ? firstfield.focus() : "";
    return isValid;
  }

  openCard(cardContainer) {
    // Use parentElement here because closest returns cardContainer
    const parentCard = cardContainer.parentElement.closest('[data-controller="card"]')
    const cardOpened = cardContainer.querySelector(`#collapseTwo[data-id="${cardContainer.dataset.id}"]`).classList.contains('show')

    if (!cardOpened) cardContainer.querySelector(`[data-action="click->card#toogle"][data-id="${cardContainer.dataset.id}"]` ).click()
    if (parentCard) this.openCard(parentCard)
  }

  submitPreDefinedTestResults(event) {
    if (!this.validateForm()) {
      event.preventDefault()
      const msg = i18next.t("Please complete the required fields");
      notify({
        message: msg,
        status: "error",
      })
      return
    }
    // Parse the URL
    const url = new URL(this.formTarget.action);
    const urlParts = url.href.split(".turbo_stream");

    axios({
      url: urlParts[0] + '.json',
      method: "POST",
      data: new FormData(this.formTarget)
    }).then(() => {
      this.visitUrl(event.detail.url, 'submission_form_tab')
    }).catch(() => {
      const msg = i18next.t("Something went wrong");
      notify({
        message: msg,
        status: "error",
      })
    })
  }

  visitUrl(url, frame) {
    Turbo.visit(url.toString(), { frame: frame });
  }

  handleFrame(e) {
    // anytime if we are going setup page, bulk upload should disappear
    if (e.target.src && e.target.src.indexOf("setup_tab") > -1) {
      this.getElement('bulk_upload_review_tab').hidden = true
      if (this.isBulkUploadValue) {
        const checkBulkUpload = this.getElement('is_bulk_upload')
        if (checkBulkUpload) {
          checkBulkUpload.click();
        }
      }
    }
    this.setTabName()
    this.toggleTabs();
    this.refreshTabs()
  }

  setTabName() {
    const content = document.querySelector(contentSelector);
    if (!content || !content.dataset) return;
    this.tabNameValue = content.dataset.tabname;
  }

  toggleTabs() {
    const tabs = this.tabsTargets.filter((elem) => !elem.parentNode.hidden)
    for (let i = 0; i < tabs.length; i++) {
      const tabElem = tabs[i];
      if (tabElem.dataset.tabname == this.tabNameValue) {
        tabElem.classList.remove("btn-light");
        tabElem.classList.add("btn-primary");
      } else {
        tabElem.classList.remove("btn-primary");
        tabElem.classList.add("btn-light");
      }
    }
  }

  loadSetupPartialByOriginType(e, existsSubmissionValue = false) {

    if (!existsSubmissionValue) {
      this.submissionOriginTypeValue = e.target.value;
    }

    let queryString = this.generateTargetUrl(e)

    if (queryString.toString().indexOf("setup_animal_breed_id") === -1) {
      queryString.append("setup_animal_breed_id", this.setupAnimalBreedIdValue);
    }

    if (queryString.toString().indexOf("setup_animal_sex_code_id") === -1) {
      queryString.append("setup_animal_sex_code_id", this.setupAnimalSexCodeIdValue);
    }

    queryString = queryString ? queryString.toString() : "";
    let url = "/portal/setup_tab_load_by_type?" + queryString;
    this.animalTabNameToggle();
    this.isBulkUploadValue = false
    this.visitUrl(url, "setup_partial_origin_type");
  }

  animalTabNameToggle() {
    let title = "";
    if (this.submissionOriginTypeValue === "product") {
      title = i18next.t("Non-Animals");
    } else if (this.submissionOriginTypeValue === "animal") {
      title = i18next.t("Animals");
    }
    this.getElement("animalTabName").innerHTML = title;
  }

  toggleAmountOfAnimal(e, getCountFromValue = false) {

    let animalCount = 1

    if (getCountFromValue) {
      animalCount = this.setupAnimalCountValue
    } else {
      if (!this.hasSetupAnimalCountTarget) return;
      animalCount = parseInt(this.setupAnimalCountTarget.value);
    }

    const item = this.getElement("specimen_main_tab_id");
    if (!animalCount && !item) return;
    item.hidden = !(animalCount > 1);
    this.refreshTabs()
  }

  toggleSetupSubmissionTypeDecision(submission_type) {
    submission_type = submission_type.toLowerCase();
    const sex_element = this.getElement("setup_animal_sex_code_decision_id");
    const breed_item = this.getElement("setup_animal_breed_decision_id");
    if (sex_element) sex_element.hidden = submission_type === "animals" ? false : true;
    if (breed_item) breed_item.hidden = submission_type === "animals" ? false : true;
  }

  toggleAmountOfAnimal(e) {
    if (!this.hasSetupAnimalCountTarget) return
    const animalCount = parseInt(this.setupAnimalCountTarget.value)
    const item = this.getElement('specimen_main_tab_id')
    if (!animalCount && !item) return
    item.hidden = !(animalCount > 1)
    this.refreshTabs()
  }

  toggleSetupSubmissionTypeDecision(submission_type) {
    submission_type = submission_type.toLowerCase()
    const sex_element = this.getElement('setup_animal_sex_code_decision_id')
    const breed_item = this.getElement('setup_animal_breed_decision_id')
    if (sex_element) sex_element.hidden = submission_type === "animals" ? false : true
    if (breed_item) breed_item.hidden = submission_type === "animals" ? false : true
  }

  getElement(id) {
    return document.getElementById(id)
  }

  checkAnimalsCount(event) {
    if (!event) return

    const animalCount = event.detail.itemCount;
    const item = this.getElement("specimen_main_tab_id");
    if (!animalCount || !item) return;

    item.hidden = !(animalCount > 1);
  }

  getElement(id) {
    return document.getElementById(id);
  }

  showBulkUploadPart(e) {
    const productItem = this.getElement("submission_origin_type_product");
    const animalItem = this.getElement("submission_origin_type_animal");

    this.submissionOriginTypeValue = "animal"
    this.getElement('submission_origin_type_animal').checked = true
    this.animalTabNameToggle();

    this.setTabName()

    const nextItem = productItem.nextElementSibling;
    const bulkUploadPart = this.getElement("bulkUploadPart");
    const nonBulkUploadPart = this.getElement("nonBulkUploadPart");

    const checked = e.target.checked;
    if (productItem) productItem.hidden = checked;
    if (nextItem) nextItem.hidden = checked;
    if (bulkUploadPart) bulkUploadPart.hidden = !checked;
    if (nonBulkUploadPart) nonBulkUploadPart.hidden = checked;

    if (checked) {
      let frame = "setup_load_bulk_upload";
      const partial = "/portal/tabs/setup/bulk_upload";
      const url = this.generateTurboLink(
        "/bulk_animal_uploads/upload",
        frame,
        partial
      );
      if (url) this.visitUrl(url, frame);
    } else {
      this.submissionOriginTypeValue = "animal"
      this.loadSetupPartialByOriginType(e, true)
    }
  }

  generateTurboLink(mainUrl, frame, partial) {
    const params = new URLSearchParams();
    params.append("id", parseInt(this.accessionIdValue));
    if (frame) params.append("frame", frame);
    if (partial) params.append("partial", partial);
    params.append("format", "turbo_stream");
    return mainUrl + "?" + params.toString();
  }

  onSubmitBulkUpload(e) {
    const files = e.target.files
    const extension = e.target.value
    const allowedExtensions = /(\.xls|\.xlsx|\.ods)$/i;
    if (!allowedExtensions.exec(extension)) {
      const msg = extension + " format not currently supported by CoreOne for labs. Please select a supported type file."
      notify({
        message: msg,
        status: "error",
      });
      e.target.classList.add("required-field");
      e.target.value = ""
      return false;
    }
  }
}

function createPortalExpressHidden() {
  const input = document.createElement("input");
  input.setAttribute("type", "hidden");
  input.setAttribute("name", "portal_express");
  input.setAttribute("value", true);
  return input
}